// supabaseClient.js
import { createClient } from '@supabase/supabase-js';

// .env 파일에 REACT_APP_SUPABASE_URL, REACT_APP_SUPABASE_ANON_KEY 지정해두었다 가정
const supabaseUrl = process.env.REACT_APP_SUPABASE_URL;
const supabaseAnonKey = process.env.REACT_APP_SUPABASE_ANON_KEY;

export const supabase = createClient(supabaseUrl, supabaseAnonKey);
